import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Highlighter from 'components/BusinessCard/components/Highlighter'
import { useBusinessCard } from 'components/BusinessCard/context'
import { H6, P } from '@PipelineDeals/shared-react-components'

const PhoneLink = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  p {
    color: ${props => props.theme.colors.blue[600]} !important;
  }
`

const LabelText = styled.span`
  text-transform: uppercase;
  font-weight: 600;
`

const PhoneNumber = ({ label, number }) => {
  const { cardMeta: { highlighter }, resource, resourceType, resourceId } = useBusinessCard()

  // Build data attributes for contact info (used by global tel: handler in CallProvider)
  const getDataAttributes = () => {
    if (resourceType === 'Person') {
      return {
        'data-contact-name': resource?.full_name || resource?.name,
        'data-person-id': resourceId,
        'data-company-id': resource?.company_id
      }
    }
    if (resourceType === 'Company') {
      return {
        'data-contact-name': resource?.name,
        'data-company-id': resourceId
      }
    }
    return {}
  }

  return (
    <>
      {label &&
        <H6>
          <LabelText>{label}</LabelText>
        </H6>}

      <PhoneLink
        href={`tel:${number}`}
        data-cypress="phone-number-link"
        {...getDataAttributes()}
      >
        <P>
          <Highlighter term={highlighter}>{number}</Highlighter>
        </P>
      </PhoneLink>
    </>
  )
}

PhoneNumber.propTypes = {
  label: PropTypes.string,
  number: PropTypes.string.isRequired
}

export default PhoneNumber
